export default "__VITE_ASSET__CDBuEtzZ__"